import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UsuarioBeneficioService {

  private selectedUsers = [];

  constructor(private readonly http: HttpClient) {}

  public cleanSelectedUsers() {
    this.selectedUsers = [];
  }

  public addUserIfNotExists(user: any): void {

    const indice = this.selectedUsers.findIndex(u => u.idUsuario == user.idUsuario);

    if(indice === -1) {
      this.selectedUsers.push(user);
    }
  }

  public removeUserIfExists(user: any): void {

    const indice = this.selectedUsers.findIndex(u => u.idUsuario == user.idUsuario);

    if(indice !== -1) {
      this.selectedUsers.splice(indice, 1);
    }
  }

  public getAllSelectedUsers(): any[] {
    return this.selectedUsers;
  }

  getAllUsuarios(idEmpresa: any, pagina: any, tamanho: any, status: any, usuario: any) {
    let nomeUsuario;
    if (usuario) {
      nomeUsuario = `&nome=${usuario}&`;
    } else { nomeUsuario = ''; }

    return this.http.get(`/apiconnect/importation/company/benefit-users/${idEmpresa}/companies?${nomeUsuario}pagina=${pagina}&status=${status}&tamanho=${tamanho}`);
  }

  getUsuarioSearchFilter(idEmpresa, searchText: string ){
    return this.http.get(`/apiconnect/importation/users/${idEmpresa}/companies/${searchText}/field-values`);
  }

  updateStatusUsers(idEmpresa, users, status){
    let obj = {
      'idEmpresa': idEmpresa,
      'idUsuarios': users,
      'status': status
    };
    return this.http.post(`/apiconnect/importation/users/status`, obj);
  }

  getUserByCompany(idEmpresa, idUsuario){
    return this.http.get(`/apiconnect/importation/users/${idEmpresa}/companies/${idUsuario}/users`);
  }

  getbenefitByIdProduct(idProduto: any){
    return this.http.get(`/apiconnect/importation/benefit/benefit-informations/${idProduto}/products`);
  }

  getUserById(idUsuario: any, idEmpresa) {

    const body : string = JSON.stringify(idUsuario);
    const headers = {
      "Content-Type": "application/json",
      "Accept": "application/json"
    };

    return this.http.post(`/apiconnect/orders/calculations/companies/${idEmpresa}/users/start`, body, {headers});
  }

  // Talvez tenha que reformular o ARRAY que envia os usuário pra adicionar um idUsuario antes dos indices, pois talvez agora,
  // não seja só enviar um array com vários idUsuario.
  deleteUserById(idUsuario: any){
    return this.http.delete(`/apiconnect//importation/users?idUsuarios=${idUsuario}`);
  }

  deleteBenefitById(idBeneficio: any){
    return this.http.delete(`/apiconnect/importation/company-product/${idBeneficio}/user-products`);
  }

  postConsultaRotaEmLote(usuarios: any){
    return this.http.post(`/apiconnect/orders/smart-route/batch-query`, usuarios);
  }

  pedidoAtivoStatus(idEmpresa: any){
    return this.http.get(`/apiconnect/orders/calculations/companies/${idEmpresa}/active-orders-status`);
  }
}
